var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_16700)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_224_16700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4683 9.0002C38.0804 9.00402 37.697 9.08456 37.3402 9.23736C36.9833 9.39016 36.6599 9.61219 36.3886 9.89066C36.1172 10.1691 35.9032 10.4988 35.7588 10.8604C35.6143 11.222 35.5423 11.6086 35.5468 11.9982V35.7105C35.547 36.497 35.8583 37.2514 36.4121 37.8075C36.9659 38.3636 37.7169 38.6758 38.5 38.6758C39.2831 38.6758 40.0341 38.3636 40.5879 37.8075C41.1417 37.2514 41.453 36.497 41.4532 35.7105V11.9982C41.4578 11.6032 41.3837 11.2112 41.2353 10.8454C41.0869 10.4796 40.8673 10.1472 40.5892 9.86786C40.3111 9.58855 39.9802 9.36802 39.616 9.21899C39.2518 9.06996 38.8616 8.99559 38.4683 9.0002ZM55.6802 14.9442C55.5842 14.9414 55.488 14.9433 55.3921 14.95C54.8088 14.9997 54.2534 15.2227 53.7966 15.5903C53.3398 15.958 53.0022 16.4537 52.8268 17.0147C52.6513 17.5756 52.6459 18.1764 52.8113 18.7404C52.9768 19.3045 53.3055 19.8063 53.7556 20.1821C58.8662 24.5412 62.0994 31.0291 62.0994 38.3148C62.0994 51.4701 51.5824 62.0734 38.5144 62.0734C25.4464 62.0734 14.9063 51.4701 14.9063 38.3148C14.9064 31.0713 18.0985 24.6274 23.1579 20.2689C23.4527 20.0162 23.695 19.7075 23.871 19.3607C24.0471 19.014 24.1534 18.6358 24.1839 18.2477C24.2144 17.8597 24.1685 17.4696 24.0489 17.0994C23.9292 16.7291 23.7381 16.3862 23.4865 16.0902C23.2349 15.7941 22.9277 15.5507 22.5824 15.3739C22.2372 15.1971 21.8606 15.0902 21.4743 15.0595C21.0879 15.0289 20.6994 15.0751 20.3308 15.1953C19.9622 15.3155 19.6207 15.5074 19.326 15.7601C13.0102 21.2009 9.00003 29.3106 9 38.3148C8.99997 54.6678 22.2522 68 38.5144 68C54.7766 68 68 54.6678 68 38.3148C68 29.2581 63.9502 21.115 57.5703 15.6734C57.0456 15.214 56.3762 14.9557 55.6802 14.9442Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_224_16700",
    x: 1,
    y: 5,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_224_16700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_224_16700",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_16700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.372ffe44e8ad227b4445f22582af3f43.svg";
export { ForwardRef as ReactComponent };